import { render, staticRenderFns } from "./DestinatariosTab.vue?vue&type=template&id=3b344752&scoped=true&"
import script from "./DestinatariosTab.vue?vue&type=script&lang=js&"
export * from "./DestinatariosTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b344752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b344752')) {
      api.createRecord('3b344752', component.options)
    } else {
      api.reload('3b344752', component.options)
    }
    module.hot.accept("./DestinatariosTab.vue?vue&type=template&id=3b344752&scoped=true&", function () {
      api.rerender('3b344752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/config/DestinatariosTab.vue"
export default component.exports